// Info: Import NPM Dependancies
import { configureStore } from '@reduxjs/toolkit';

// Info: Import Local Dependancies
import sitecoreReducer from "./sitecoreSlice";
import feedbackReducer from './feedbackSlice';
export const store = configureStore({
  reducer: {
    sitecore: sitecoreReducer,
    feedback: feedbackReducer,
  }
});

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export default store;
